import React, { FC } from 'react';
import ViewPdfLink from 'components/ui/ViewPdfLink';
import { isPdfPath, resolveUploadFileUrl } from 'helpers/resolveUploadFileUrl';

interface UploadImageThumbProps {
    path: string | null | undefined;
    alt?: string;
    className?: string;
}

const UploadImageThumb: FC<UploadImageThumbProps> = ({ path, alt = 'upload preview', className }) => {
    if (!path || path === '-') {
        return <span className="text-gray-500">-</span>;
    }

    if (isPdfPath(path)) {
        return <ViewPdfLink path={path} className={className} />;
    }

    const href = resolveUploadFileUrl(path);
    return (
        <a href={href} target="_blank" rel="noreferrer">
            <img
                src={href}
                alt={alt}
                className={
                    className ||
                    'mx-auto h-10 w-10 rounded-md border border-gray-200 object-cover hover:opacity-80'
                }
            />
        </a>
    );
};

export default UploadImageThumb;
